import { gridDisk } from 'h3-js'

// Function to check if two plots are neighbors
export function plotsAreNeighbours(plot1: string, plot2: string): boolean {
	return gridDisk(plot1, 1).includes(plot2)
}

// Helper function to find root of plot
export function findRoot(plot: string, parent: Map<string, string>): string {
	while (plot !== parent.get(plot)) {
		plot = parent.get(plot)!
	}
	return plot
}

// Function to union two plots
function unionPlots(
	plot1: string,
	plot2: string,
	parent: Map<string, string>,
	rank: Map<string, number>,
) {
	let root1 = findRoot(plot1, parent)
	let root2 = findRoot(plot2, parent)

	if (root1 === root2) return

	if (rank.get(root1)! < rank.get(root2)!) {
		parent.set(root1, root2)
	} else if (rank.get(root1)! > rank.get(root2)!) {
		parent.set(root2, root1)
	} else {
		parent.set(root2, root1)
		rank.set(root1, rank.get(root1)! + 1)
	}
}

// Function to group neighboring plots and identify single plots
export function groupPlots(plots: string[]): {
	groupedPlots: string[][]
	singlePlots: string[]
} {
	const parent = new Map<string, string>()
	const rank = new Map<string, number>()
	const groupedPlots: string[][] = []
	const singlePlots: string[] = []

	// Initialize parent and rank
	plots.forEach(plot => {
		parent.set(plot, plot)
		rank.set(plot, 0)
	})

	// Union plots if they are neighbors
	plots.forEach(plot => {
		plots.forEach(otherPlot => {
			if (plot !== otherPlot && plotsAreNeighbours(plot, otherPlot)) {
				unionPlots(plot, otherPlot, parent, rank)
			}
		})
	})

	// Find connected components
	const components = new Map<string, string[]>()
	plots.forEach(plot => {
		const root = findRoot(plot, parent)
		if (!components.has(root)) {
			components.set(root, [])
		}
		components.get(root)!.push(plot)
	})

	// Populate groupedPlots and singlePlots based on components
	components.forEach(component => {
		if (component.length > 1) {
			groupedPlots.push(component)
		} else {
			singlePlots.push(component[0])
		}
	})

	return { groupedPlots, singlePlots }
}
